import { TransText } from '@/i18n/trans/text';
import { cn } from '@/utils/cn';
import { Icons, Typography } from '@fleet/webshop-ui';
import { type FC } from 'react';

interface PromoCodeProps {
  code?: string;
  description?: string;
  className?: string;
}

const PromoCode: FC<PromoCodeProps> = ({ code, description, className }) => {
  return (
    <div
      className={cn(
        'flex justify-between gap-2 rounded-sm border border-success-border bg-success-surface p-2',
        className
      )}
    >
      <Icons.checkCircle width={16} height={16} className="text-success-text" />
      <div className="flex flex-1 flex-col gap-1">
        <Typography variant="body2">
          <span>
            <TransText i18nKey="appliedCode" />
            {': '}
          </span>
          <Typography variant="body2-bold" as="span">
            {code}
          </Typography>
        </Typography>
        {description && (
          <Typography variant="body2" className="text-neutral">
            {description}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default PromoCode;
